module.exports = __webpack_public_path__ + "static/media/13_l_dom_14.79_76.2.75922168.png";